<tellent-assistant-trigger [collapsed]="collapsed()" (triggered)="toggle()" />
